import { render, staticRenderFns } from "./NavBar-2.vue?vue&type=template&id=b7d12026&scoped=true&"
import script from "./NavBar-2.vue?vue&type=script&lang=js&"
export * from "./NavBar-2.vue?vue&type=script&lang=js&"
import style0 from "./NavBar-2.vue?vue&type=style&index=0&id=b7d12026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d12026",
  null
  
)

export default component.exports